import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import adicionarFiltroUsuario from '../../../actions/usuario/adicionarFiltroUsuario'
import removerFiltroUsuario from '../../../actions/usuario/removerFiltroUsuario'
import listarFiltrosUsuario from '../../../actions/usuario/listarFiltrosUsuario'
import {
    FILTRO_AGENCIA,
    FILTRO_CODIGO_USUARIO,
    FILTRO_DATA_CRIACAO,
    FILTRO_EMAIL_USUARIO,
    FILTRO_NOME_EMPRESA,
    FILTRO_NOME_USUARIO,
    FILTRO_PERFIL,
    FILTRO_STATUS_USUARIO,
    FILTRO_USUARIO_SISTEMA
} from '../../../util/filtros'
import FiltroBuscaUsuario from './FiltroBuscaUsuario';
import Autorizacao from '../../../security/Autorizacao';
import { PERFIL_ADMIN } from '../../../security/securityContext';
import { FiltroChaveValor } from '../../comum/FiltroChaveValor';
import { alterouEmpresa } from '../../../actions/empresa/alterarEmpresaSelecionada';
export class FiltroUsuarios extends Component {
    componentDidMount() {
        if (this.props.empresaSelecionada && this.props.empresaSelecionada.id) {
            this.props.listarFiltrosUsuario(this.props.empresaSelecionada.id)
        }
    }

    componentDidUpdate(prevProps) {
        if (alterouEmpresa(this.props, prevProps)) {
            this.props.listarFiltrosUsuario(this.props.empresaSelecionada.id)
        }
    }

    adicionarFiltro(filtro) {
        this.props.adicionarFiltroUsuario(filtro)
    }

    removerFiltro(filtro) {
        this.props.removerFiltroUsuario(filtro)
    }

    render() {
        return (
            <React.Fragment>
                <div className="conteudo">
                    <Autorizacao perfisPermitidos={[PERFIL_ADMIN]}>
                        <FiltroBuscaUsuario
                            filtro={FILTRO_DATA_CRIACAO}
                            opcoes={[new Date().getFullYear()]}
                            isFiltroData={true}
                        />
                    </Autorizacao>
                    <FiltroBuscaUsuario
                        filtro={FILTRO_CODIGO_USUARIO}
                        isNumero={true}
                    />
                    <FiltroBuscaUsuario
                        filtro={FILTRO_NOME_USUARIO}
                        isNome={true}
                        opcoes={[]}
                    />
                    <FiltroBuscaUsuario
                        filtro={FILTRO_EMAIL_USUARIO}
                        isNome={true}
                        opcoes={[]}
                    />
                    <FiltroBuscaUsuario
                        filtro={FILTRO_STATUS_USUARIO}
                        opcoes={['Ativo', 'Inativo']}
                        isRadio={true}
                    />
                    <Autorizacao perfisPermitidos={[PERFIL_ADMIN]}>
                        <FiltroBuscaUsuario
                            filtro={FILTRO_USUARIO_SISTEMA}
                            isRadio={true}
                            opcoes={['Sim']}
                        />
                    </Autorizacao>
                    <FiltroChaveValor
                        filtro={FILTRO_PERFIL}
                        opcoes={this.props.perfis}
                        filtrosAdicionados={this.props.filtrosAdicionados}
                        adicionarFiltro={this.adicionarFiltro.bind(this)}
                        removerFiltro={this.removerFiltro.bind(this)}
                    />
                    <Autorizacao perfisPermitidos={[PERFIL_ADMIN]}>
                        <FiltroBuscaUsuario
                            filtro={FILTRO_NOME_EMPRESA}
                            isNome={true}
                            opcoes={[]}
                        />
                    </Autorizacao>
                    <FiltroBuscaUsuario
                        filtro={FILTRO_AGENCIA}
                        isNome={true}
                        opcoes={[]}

                    />

                </div>
            </React.Fragment>
        )
    }
}

export const mapStateToProps = state => ({
    perfis: state.filtrosUsuarios.perfis,
    filtrosAdicionados: state.filtrosAdicionadosUsuarios,
    empresaSelecionada: state.empresaSelecionada

})

export const mapDispatchToProps = dispatch => (
    bindActionCreators({
        adicionarFiltroUsuario,
        removerFiltroUsuario,
        listarFiltrosUsuario
    }, dispatch)
)

export default connect(mapStateToProps, mapDispatchToProps)(FiltroUsuarios)
